import { z } from 'zod';

/**
 * Decision register entry — the leadership team's audit trail of choices.
 */
export const DecisionStatusSchema = z.enum(['open', 'decided', 'implemented']);
export type DecisionStatus = z.infer<typeof DecisionStatusSchema>;

export const DecisionSchema = z.object({
  id: z.string(),
  title: z.string().min(1).max(200),
  context: z.string().default(''),
  decision: z.string().default(''),
  owner: z.string().default(''),
  dueDate: z.string().nullable(),
  status: DecisionStatusSchema.default('open'),
  outcome: z.string().default(''),
  createdAt: z.string(),
  decidedAt: z.string().nullable(),
  implementedAt: z.string().nullable(),
});

export type Decision = z.infer<typeof DecisionSchema>;
